import { render } from "./SolicitacaoEntradaEprodView.vue?vue&type=template&id=8a015ca6"
import script from "./SolicitacaoEntradaEprodView.vue?vue&type=script&lang=js"
export * from "./SolicitacaoEntradaEprodView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__